import React, {useContext} from "react";
import {formatCurrency, formatDate, handleDefaultValues} from "../../common/Utils";
import {Card, CardContent, Chip, Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import {Col, Row} from "react-bootstrap";
import {CONSTANTS} from "../../common/constants";
import LoopIcon from '@mui/icons-material/Loop';
import {Looks} from "@mui/icons-material";
import MDButton from "../../../components/MDButton";
import {addToCart} from "../../common/api/PortalCustomerApi";
import {CartContext} from "../../../lib/CartProvider";

export default function CustomerPerksCardsMiniPane({perks}) {

  const [cartContext, setCartContext] = useContext(CartContext);

  return (
    <>
      <MDBox>
        <Grid container cols={2} spacing={2} direction="row">
          <Grid item sm={12}>
            {perks?.length > 0 && <Card className={'mt-4'}>
              <CardContent>
                <h5>
                  Member Perks
                </h5>
                <Divider/>
                <Row>
                  <Col sm={12}>
                    <ul className={'list-group'}>
                      {perks?.map((perk, idx) => {
                        return (
                          <li
                            className={'list-group-item'}
                            key={idx}>

                            <b>Name:</b> {perk.name}
                            <br/>

                            <p>
                              <small>
                                <b>Type:</b> {perk?.perkType?.name}<br/>
                                {perk?.perkType?.id === CONSTANTS.PERK_TYPE.PRODUCT && <>
                                  <b>Item:</b> {perk.inventory?.name}
                                </>}
                                {perk?.perkType?.id === CONSTANTS.PERK_TYPE.DISCOUNT && <>
                                  <b>Discount:</b> {perk.discountPercentage}%
                                </>}
                                {perk?.perkType?.id === CONSTANTS.PERK_TYPE.CREDIT && <>
                                  <b>Credit:</b> {formatCurrency(perk.storeCreditValue)} <br/>
                                  <b>Balance:</b> {formatCurrency(perk.storeCreditBalance)}
                                </>}<br/>
                                <b>Recurrence:</b> {perk?.recurrenceType?.name}
                                {perk?.timeRestricted && <><br/>
                                  <b>Expires:</b> {formatDate(perk?.expirationDate)}
                                </>}
                                <br/>
                                <b>Unlimited:</b> {perk?.unlimitedUsage ? 'Yes' : 'No'}
                              </small>
                            </p>
                            <Chip className={'m-chip'}
                                  color="secondary"
                                  variant="outlined"
                                  label={'Created on: ' + (formatDate(perk.createDate))} />

                            {perk?.unlimitedUsage && <Chip className={'mb-2'}
                                                           color="secondary"
                                                           icon={<LoopIcon />}
                                                           variant="outlined"
                                                           label={' Unlimited'} /> }
                            {perk?.perkType?.id === CONSTANTS.PERK_TYPE.PRODUCT && <>
                              <MDButton className={'pull-right mr-2'} color="info" size={"small"}
                                onClick={(e)=>{
                                  addToCart(perk.inventory).then((r) => {
                                    setCartContext({...cartContext, reloadCart: true, viewCart: true, caller: 'Register Add to cart fn'});
                                  })

                              }}>Redeem</MDButton>
                            </>
                            }
                          </li>
                        )
                      })
                      }
                    </ul>
                  </Col>
                </Row>
              </CardContent>
            </Card>
            }
          </Grid>
        </Grid>
      </MDBox>

    </>
  )
}